import { color } from "@moneyforward/mfx_biz_react_components";

export const ServiceUnavailableDashIcon = () => {
  return (
    <div
      css={{
        height: 2,
        width: 14,
        backgroundColor: color.gray600,
      }}
    ></div>
  );
};
